import {
    useLayoutEffect,
    useState
} from "react";
import type {
    AnimatedIconValueConstantType
} from "./type";

const useAnimatedIconValue = ({
    isStatic = false,
    initialValue,
    progress
}: AnimatedIconValueConstantType): number => {
    const [
        value,
        setValue
    ] = useState(initialValue);

    useLayoutEffect(() => {
        if(isStatic) {
            return;
        }

        setValue(initialValue);

        const listenerId = progress.addListener(({
            value: nextValue
        }) => {
            setValue(nextValue);
        });

        return () => {
            progress.removeListener(listenerId);
        };
    }, [
        initialValue,
        isStatic,
        progress
    ]);

    return value;
};
export default useAnimatedIconValue;
